import { forwardRef } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { MEDIA_QUERY } from '@bucketplace/design-system';

import { DOCUMENTARY_SIZE } from '../../constants';

export interface DocumentaryVideoProps {
  src: string;
  autoPlay?: boolean;
  muted?: boolean;
  loop?: boolean;
  playsInline?: boolean;
}

/** 미니 다큐 비디오 */
export const DocumentaryVideo = forwardRef<HTMLVideoElement, DocumentaryVideoProps>((props, ref) => {
  return (
    <StyledVideo
      ref={ref}
      src={props.src}
      autoPlay={props.autoPlay ?? true}
      muted={props.muted ?? true}
      loop={props.loop ?? true}
      preload="metadata"
      playsInline={props.playsInline ?? true}
    />
  );
});

DocumentaryVideo.displayName = 'DocumentaryVideo';

export const VideoSectionWrapper = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  justify-content: center;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.70) 100%);
    pointer-events: none;
  }
`;

/** 비디오 컨테이너 */
export const VideoContainer = styled.div`
  position: absolute;
  
  width: ${DOCUMENTARY_SIZE.mobile.width}px;
  height: ${DOCUMENTARY_SIZE.mobile.height}px;
  border-radius: 16px;
  overflow: hidden;

  ${MEDIA_QUERY.min('tablet', css`
    width: ${DOCUMENTARY_SIZE.tablet.width}px;
    height: ${DOCUMENTARY_SIZE.tablet.height}px;
  `)}

  ${MEDIA_QUERY.min('laptop', css`
    width: ${DOCUMENTARY_SIZE.laptop.width}px;
    height: ${DOCUMENTARY_SIZE.laptop.height}px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `)}

  & > video {
    &:first-of-type {
      border-radius: 16px 16px 0 0;
    }
    
    &:last-of-type {
      border-radius: 0 0 16px 16px;
    }
  }
`;

const StyledVideo = styled.video`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  object-fit: cover;
`;
